import React from 'react';
import classes from './Images.module.scss';

import { getEnv } from '@config';

const { publicPath } = getEnv();

export default function Images({ className }) {
  return (
    <div className={classes.image} id="contain-img-images">
      <img src={`${publicPath}/adjuntar.svg`} id="logo-adjuntar-imagen" alt="logo de adjuntar" />
    </div>
  );
}
